/** Display name for the user who created a record (invoice, expense, etc.). */
export function creatorDisplayName(record?: { creator?: { username?: string } | null }): string {
  const name = record?.creator?.username?.trim();
  return name || '—';
}
